// extracted by mini-css-extract-plugin
export var header = "_gp-0";